module.exports = __webpack_public_path__ + "static/media/stat.0b14b6e8.svg";